import { matchPath } from 'react-router-dom';

/**
 * Returns the matched path between full path and path to match
 * @param {string} fullPath - full path of route
 * @param {string} pathToMatch - path to compare against the full path
 */
export const getMatchPath = (fullPath: string, pathToMatch: string) => {
  return matchPath(pathToMatch, fullPath);
};
